/* eslint-disable @typescript-eslint/no-floating-promises */
import 'react-loading-skeleton/dist/skeleton.css'
import './public-path'
// @ts-expect-error
import 'swiper/css/bundle'
import { H } from 'highlight.run'
import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import { mapValues, mergeDeep } from 'remeda'
import type {} from 'styled-components/cssprop'
import { renderApparelCollectionApp } from '@apps/ApparelCollectionApp'
import { renderApparelMacroCategoryApp } from '@apps/ApparelMacroCategoryApp'
import { renderApparelProductPageApp } from '@apps/ApparelProductPageApp'
import { renderBannerNotRightStore } from '@apps/BannerNotRightStoreApp'
import { renderBottegasApp } from '@apps/BottegasApp'
import { renderBottegasRinascenteApp } from '@apps/BottegasRinascenteApp'
import { renderCartPageApp } from '@apps/CartPageApp'
import { renderCategoriesBlocksApp } from '@apps/CategoriesBlocksApp'
import { renderCollectionShowcasePageApp } from '@apps/CollectionShowcasePageApp'
import { renderCollectionTextLoginApp } from '@apps/CollectionTextLoginApp'
import { renderCollectionTopMessageApp } from '@apps/CollectionTopMessageApp'
import { renderFooterApp } from '@apps/FooterApp'
import { renderGiftCardPageApp } from '@apps/GiftCardPageApp'
import { renderHeaderApp } from '@apps/HeaderApp'
import { renderLookbookPageApp } from '@apps/LookbookPageApp'
import { renderMediaCarouselApp } from '@apps/MediaCarouselApp'
import { renderNewsletterSectionApp } from '@apps/NewsletterSectionApp'
import { renderPromotionalBannerApp } from '@apps/PromotionalBannerApp'
import { renderRecentProductsApp } from '@apps/RecentProductsApp'
import { renderRecentProductsLiquidCollectionApp } from '@apps/RecentProductsLiquidCollectionApp'
import { renderRecentProductTrackerApp } from '@apps/RecentProductTrackerApp'
import { renderRelatedProductsApp } from '@apps/RelatedProductsApp'
import { renderPage404App } from '@apps/render404App'
import { renderHomePageApp } from '@apps/renderHomePageApp'
import { renderSwitchStoreApp } from '@apps/SwitchStoreApp'
import { convertToI18nTemplateString } from '@velasca/utils/convert-to-i18n-template-string'
import { cssPolyfill } from '@velasca/utils/css-polyfill'
import { $settings, isWoman } from '@velasca/utils/globals'
import { hasCompatibleSafariVersion } from '@velasca/utils/has-compatible-safari-version'
import { parseJSONSafe } from '@velasca/utils/parse-json-safe'

const isDevelopementTheme = window.Shopify?.theme?.role === 'development'

// Maybe this could be done in a more elegant way, but as of right now the docs are very unclear on the matter.
if (!isDevelopementTheme) {
  H.init('ney3qp1d', {
    serviceName: isWoman ? 'storefront-woman' : 'storefront-man',
    tracingOrigins: true,
    environment: isDevelopementTheme ? 'development' : 'production',
    networkRecording: {
      enabled: true,
    },
  })
}

const BannerNotRightStoreDataEl = document.querySelector(
  '#banner-not-right-store-data',
)
const BannerNotRightStoreData = parseJSONSafe(
  BannerNotRightStoreDataEl?.innerHTML || '{}',
)

const homePageEl = document.querySelector<HTMLElement>('#homepage')

const apparelProductEl = document.querySelector<HTMLElement>('#apparel-product')
const cartPageEl = document.querySelector<HTMLElement>('#cart-page')
const giftCardProductEl =
  document.querySelector<HTMLElement>('#gift-card-product')
const productLocaleEl = document.querySelector<HTMLElement>(
  '#product-locale-json',
)
const productLocaleElJson = productLocaleEl
  ? parseJSONSafe(productLocaleEl.innerText)
  : {}
const productLocaleGiftCardEl = document.querySelector<HTMLElement>(
  '#product-gift-card-locale-json',
)
const productLocaleGiftCardElJson = productLocaleGiftCardEl
  ? parseJSONSafe(productLocaleGiftCardEl.innerText)
  : {}
const switchCountryLocaleEl = document.querySelector<HTMLElement>(
  '#switch-country-json',
)
const switchCountryLocaleElJson = switchCountryLocaleEl
  ? parseJSONSafe(switchCountryLocaleEl.innerText)
  : {}
const headerDataEl = document.querySelector<HTMLElement>('#header-data')
const headerData = headerDataEl ? parseJSONSafe(headerDataEl.innerText) : {}

const promotionalBannerDataEl = document.querySelector<HTMLElement>(
  '#promotional-banner-data',
)
const promotionalBannerData = promotionalBannerDataEl
  ? parseJSONSafe(promotionalBannerDataEl.innerText)
  : {}
const headerEl = document.querySelector<HTMLElement>('#header')
const relatedProductsSettingsEl = document.querySelector<HTMLElement>(
  '#related-products-settings-json',
)
const relatedProductsSettingsJson = relatedProductsSettingsEl
  ? parseJSONSafe(relatedProductsSettingsEl.innerText)
  : {}
const recentProductsSettingsEl = document.querySelector<HTMLElement>(
  '#recent-products-settings-json',
)
const recentProductsSettingsJson = recentProductsSettingsEl
  ? parseJSONSafe(recentProductsSettingsEl.innerText)
  : {}
const switchCountryEl = document.querySelector<HTMLElement>('#switch-country')
const apparelCategoryEl =
  document.querySelector<HTMLElement>('#apparel-category')
const apparelMacroCategoryEl = document.querySelector<HTMLElement>(
  '#apparel-macro-category',
)
const collectionTopMessageEl = document.querySelector<HTMLElement>(
  '#collection-top-message',
)
const collectionTopMessageJson = document.querySelector<HTMLElement>(
  '#collection-top-message-data',
)
const collectionTopMessageData = collectionTopMessageJson
  ? parseJSONSafe(collectionTopMessageJson.innerText)
  : {}

const cartDrawerDataEl =
  document.querySelector<HTMLElement>('#cart-drawer-data')
const cartDrawerData = cartDrawerDataEl
  ? parseJSONSafe(cartDrawerDataEl.innerText, { fallbackValue: [] })
  : []

const filtersLocaleEl = document.querySelector<HTMLElement>(
  '#collection-filter-labels',
)
const filtersLocaleElJson = filtersLocaleEl
  ? parseJSONSafe(filtersLocaleEl.innerText)
  : {}

const cartPageDataEl = document.querySelector<HTMLElement>('#cart-page-json')
const cartPageData = cartPageDataEl
  ? parseJSONSafe(cartPageDataEl.innerText, { fallbackValue: [] })
  : []

const visualTopImageEl = document.getElementById('visual-top-image-json')
const visualTopImageElData = visualTopImageEl
  ? parseJSONSafe(visualTopImageEl.innerText, {
      fallbackValue: {},
    })
  : {}

const categoriesBlocksEl =
  document.querySelector<HTMLElement>('#categories-blocks')
const categoriesBlocksDataEl = document.querySelector<HTMLElement>(
  '#categories-blocks-json',
)
const categoriesBlocksData = categoriesBlocksDataEl
  ? parseJSONSafe(categoriesBlocksDataEl.innerText, { fallbackValue: [] })
  : {}

const page404El = document.querySelector<HTMLElement>('#page-404')

const newsletterSectionEl = document.querySelector<HTMLElement>(
  '#newsletter-section',
)
const newsletterSectionDataEl = document.querySelector<HTMLElement>(
  '#newsletter-section-data',
)
const newsletterSectionData = newsletterSectionDataEl
  ? parseJSONSafe(newsletterSectionDataEl.innerText)
  : {}

const heroDataEl = document.querySelector<HTMLElement>('#hero-json')
const heroData = heroDataEl
  ? parseJSONSafe(heroDataEl.innerText, { fallbackValue: [] })
  : {}

cssPolyfill()

// Need to convert %string% to {{string}} because i18next doesn't support it
const bannerNotRightStoreI18nTranslations = mapValues(
  BannerNotRightStoreData.translations,
  (value) => mapValues(value, convertToI18nTemplateString),
)

const currentLanguageTranslations = {
  [$settings.language ?? 'it']: {
    global: $settings,
    header: headerData?.translations,
    cartDrawer: cartDrawerData?.translations,
    cartPage: cartPageData?.translations,
    product: {
      ...productLocaleElJson.product,
      ...productLocaleGiftCardElJson,
    },
    recentProducts: recentProductsSettingsJson?.translations,
    ...switchCountryLocaleElJson,
    ...filtersLocaleElJson,
  },
}

const i18nConfig = {
  lng: $settings.language,
  resources: mergeDeep(
    currentLanguageTranslations,
    // i18next wants an object with language codes as keys and translations as values. See banner-not-right-store.liquid for original JSON structure
    mapValues(bannerNotRightStoreI18nTranslations, (value) => ({
      bannerNotRightStore: value,
    })),
  ),
}

i18next.use(initReactI18next).init(i18nConfig)
// i18next.services?.formatter?add('capitalize', (value: string) => {
//   return `${value.substr(0, 1).toUpperCase()}${value.substr(1).toLowerCase()}`
// })
i18next.services?.formatter?.add('lowercase', (value: string) => {
  return value.toLowerCase()
})

// Lazy size optimizations
window.lazySizesConfig = window.lazySizesConfig || {}
window.lazySizesConfig.expand = 1000

const tabletMediaQuery = window.matchMedia(
  '(min-width: 768px) and (max-width: 991px)',
)
const desktopMediaQuery = window.matchMedia('(min-width: 992px)')

const setExpFactor = ({
  isDesktop,
  isTablet,
}: {
  isDesktop: boolean
  isTablet: boolean
}) => {
  if (isDesktop) {
    window.lazySizesConfig.expFactor = 2
  } else if (isTablet) {
    window.lazySizesConfig.expFactor = 3
  } else {
    window.lazySizesConfig.expFactor = 4
  }
}

// Safari 14< doesn't support MediaQueryList.addEventListener https://caniuse.com/matchmedia
// Targeting older safari versions and setting desktop expFactor (2)
if (
  hasCompatibleSafariVersion(navigator.userAgent, {
    comparisonOperator: 'lower',
    version: 14,
  })
) {
  window.lazySizesConfig.expFactor = 2
} else {
  window.addEventListener('load', () => {
    setExpFactor({
      isDesktop: desktopMediaQuery.matches,
      isTablet: tabletMediaQuery.matches,
    })
  })

  tabletMediaQuery.addEventListener('change', (e) => {
    setExpFactor({
      isDesktop: desktopMediaQuery.matches,
      isTablet: e.matches,
    })
  })

  desktopMediaQuery.addEventListener('change', (e) => {
    setExpFactor({
      isDesktop: e.matches,
      isTablet: tabletMediaQuery.matches,
    })
  })
}

renderHomePageApp({
  heroData,
  homePageEl,
  cartDrawerData,
  headerEl,
  headerData,
  promotionalBannerData,
  categoriesBlocksData,
})

renderCategoriesBlocksApp(categoriesBlocksEl, categoriesBlocksData)

renderLookbookPageApp({ heroData })

renderApparelProductPageApp(
  cartDrawerData,
  headerEl,
  headerData,
  relatedProductsSettingsJson,
  recentProductsSettingsJson,
  promotionalBannerData,
)

renderGiftCardPageApp(
  cartDrawerData,
  headerEl,
  headerData,
  promotionalBannerData,
)

renderCartPageApp(cartDrawerData, headerEl, headerData, promotionalBannerData)

renderApparelCollectionApp(
  apparelCategoryEl,
  visualTopImageElData,
  cartDrawerData,
  headerEl,
  headerData,
  promotionalBannerData,
  collectionTopMessageData,
)
renderApparelMacroCategoryApp(
  apparelMacroCategoryEl,
  visualTopImageElData,
  cartDrawerData,
  headerEl,
  headerData,
  promotionalBannerData,
  productLocaleElJson,
  collectionTopMessageData,
)
renderHeaderApp(
  homePageEl,
  switchCountryEl,
  cartPageEl,
  giftCardProductEl,
  apparelProductEl,
  apparelCategoryEl,
  apparelMacroCategoryEl,
  cartDrawerData,
  headerEl,
  headerDataEl,
  headerData,
  promotionalBannerData,
)
renderCollectionShowcasePageApp()
renderCollectionTextLoginApp()
renderCollectionTopMessageApp(collectionTopMessageEl, collectionTopMessageData)
renderRecentProductsApp()
renderRecentProductsLiquidCollectionApp()
renderRecentProductTrackerApp()
renderPromotionalBannerApp(promotionalBannerData)
renderBottegasRinascenteApp()
renderBottegasApp()
renderMediaCarouselApp()
renderRelatedProductsApp(relatedProductsSettingsJson)
renderSwitchStoreApp(switchCountryEl)
renderNewsletterSectionApp(newsletterSectionEl, newsletterSectionData)
renderFooterApp({ menu: headerData?.nav })
renderPage404App({ page404El, categoriesBlocksData })
renderBannerNotRightStore()
